<template>
  <com-page>
    <com-card>
      <div class="h-500px">
        <div class="w-500px">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="80px">
            <el-form-item label="旧密码" prop="oldPassword">
              <el-input v-model="ruleForm.oldPassword" placeholder="旧密码"></el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="newPassword">
              <el-input v-model="ruleForm.newPassword" placeholder="新密码"></el-input>
            </el-form-item>
          </el-form>
          <div class="mt-15px flex justify-end">
            <el-button @click="cancel">取消</el-button>
            <el-button type="primary" @click="submitForm('ruleForm')" :disabled="disabled"
              >确定</el-button
            >
          </div>
        </div>
      </div>
    </com-card>
  </com-page>
</template>

<script>
import { changeAuditPwd } from '@/api/auth'

export default {
  data() {
    return {
      ruleForm: {},
      rules: {
        oldPassword: [{ required: true, message: '请输入旧密码', trigger: 'blur' }],
        newPassword: [{ required: true, message: '请输入新密码', trigger: 'blur' }]
      },
      disabled: false
    }
  },
  methods: {
    cancel() {
      this.ruleForm = {}
    },
    submitForm(formName) {
      console.log('object :>> ', this.ruleForm)
      // eslint-disable-next-line consistent-return
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.disabled = true
          changeAuditPwd(this.ruleForm)
            .then((res) => {
              this.disabled = false
              if (res.status === 200) {
                this.$message.success('操作成功')
                this.ruleForm = {}
              }
              console.log('res :>> ', res)
            })
            .catch(() => {
              this.disabled = false
            })
        }
      })
    }
  }
}
</script>
